import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../globalStore/store';
import { setPassword, setUserName } from '../../reducers/user/userSlice';
import RegistrationLayout from '../../Components/layout/RegistrationLayout';
import KeyIcon from '@mui/icons-material/Key';
import { Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import RegistrationFormBox from '../../Components/layout/RegistrationFormBox';
import { useNotify } from '../../util/hooks/notify/Notification';
import { useAuth } from '../../util/Auth/AuthProvider';

const Login = () => {
  const userName: string = useSelector((state: RootState) => state.user.userName);
  const password: string = useSelector((state: RootState) => state.user.password);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = React.useState(false);
  const notify = useNotify();
  const { loginWithRedirect } = useAuth();
  const navigate = useNavigate();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    try {
      await loginWithRedirect(userName, password, '/dashboard');
    } catch (error) {
      notify('Hibás felhasználónév vagy jelszó.', 'error');
    }
  };

  return (
    <RegistrationLayout>
      <RegistrationFormBox text={"Bejelentkezés"} icon={<KeyIcon sx={{ fontSize: '30px', transform: 'rotate(90deg)' }} />}>
        <hr style={{ width: '100%' }} />
        <TextField
          fullWidth
          name={'email'}
          type="email"
          value={userName}
          onChange={(e) => dispatch(setUserName(e.target.value))}
          autoComplete={'off'}
          label={'Email cím'}
        />
        <TextField
          label="Jelszó"
          variant="outlined"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          value={password}
          onChange={(e) => dispatch(setPassword(e.target.value))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleTogglePassword}
                  edge="end"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <Visibility />  : <VisibilityOff /> }
                </IconButton>
              </InputAdornment>
            ),
          }}
          autoComplete={'new-password'}
        />
        <Typography variant={'caption'} color={'textSecondary'}>{'Elfelejtettem a jelszavam. '} <Link style={{color: 'black'}} to={'/forgotPassword'}>{"Új jelszó igénylése itt"}</Link> </Typography>
        <Button variant={'contained'} sx={{width: '100%'}} color={'primary'} onClick={handleLogin}>{'Bejelentkezek emaillel'}</Button>
        <hr style={{width: '100%'}}/>
        <Typography variant={'h6'} fontWeight={"lighter"} color={'textSecondary'}>{'Még nincs PinkPOS fiókod? '} </Typography>
        <Button variant={'contained'} sx={{backgroundColor: '#FCD9E8', borderRadius: '30px', textTransform: 'none', fontWeight: 'lighter', color: '#291520', width: '100%'}}
                onClick={() => navigate('/registration')}>
          {"Regisztrálok ingyen"}
        </Button>
      </RegistrationFormBox>
    </RegistrationLayout>
  );
};

export default Login;